export const buildProvenance = { "commitHash": "0f9423725db6eb5ab5abcc7363605a9d61f7a736", "branchName": "refs/heads/release/2023.4", "buildDate": "2023-12-20T12:51:09.189Z", "version": "2023.4.8196" };
